import React from 'react'
import { createRoot } from 'react-dom/client';
import StakingApp from '../react/components/StakingPageApp';

// Render your React component instead
const root = createRoot(document.getElementById('app'));
root.render(<StakingApp />);
